import React from 'react';

const ProfileSVG = () => (
  <svg
    fill="#000000"
    x="0px"
    y="0px"
    viewBox="0 0 500 500"
  >
    <path d="M357.1,126.2c-0.5-4.3-4.4-8.2-8.6-8.7c-65.8-7.1-131.3-7.1-197.1,0c-4.2,0.5-8.1,4.4-8.6,8.7  c-9,82.6-9,164.9,0,247.5c0.5,4.3,4.4,8.2,8.6,8.7c65.8,7.1,131.3,7.1,197.1,0c4.2-0.5,8.1-4.4,8.6-8.7  C366.1,291.2,366.1,208.8,357.1,126.2z M250,163.1c22.1,0,41.7,19.6,42.1,41.8c0.4,22.8-20.1,41.2-42.1,41.2  c-22.1,0-42.5-18.4-42.1-41.2C208.3,182.7,227.9,163.1,250,163.1z M318.7,324.4c-0.2,4.3-0.3,6.4-0.5,10.7  c-45.5,2.1-90.9,2.1-136.4,0c-0.2-4.3-0.3-6.4-0.5-10.7c-1.6-33,29.3-60.7,61.3-59.9c5.9,0,8.9,0,14.8,0  C289.2,264.5,321.2,291.1,318.7,324.4z" />
  </svg>
);

export default ProfileSVG;
